import React, { useEffect, useState } from "react";
import "./RepublicDayEvent.css";

const republicImages = [
  {
    id: 1,
    src: "/events/republic1.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 2,
    src: "/events/republic2.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 3,
    src: "/events/republic3.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 4,
    src: "/events/republic4.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 5,
    src: "/events/republic5.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 6,
    src: "/events/republic6.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 7,
    src: "/events/republic7.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 8,
    src: "/events/republic8.png",
    alt: "Republic Day celebration activity",
  },
   {
    id: 9,
    src: "/events/republic9.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 10,
    src: "/events/republic10.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 11,
    src: "/events/republic11.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 12,
    src: "/events/republic12.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 13,
    src: "/events/republic13.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 14,
    src: "/events/republic14.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 15,
    src: "/events/republic15.png",
    alt: "Republic Day celebration activity",
  },
  {
    id: 16,
    src: "/events/republic16.png",
    alt: "Republic Day celebration activity",
  },
];

export default function RepublicDayEvent() {
  useEffect(() => {
    document.title = "Republic Day Celebration | Gifted Child Therapy";
  }, []);

  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  const openImage = (image) => {
    setSelectedImage(image);
    setZoomLevel(1);
    document.body.style.overflow = "hidden";
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  };

  const handleZoom = (e) => {
    e.preventDefault();
    const zoom = zoomLevel + e.deltaY * -0.001;
    if (zoom > 0.5 && zoom < 5) setZoomLevel(zoom);
  };

  return (
    <div className="republic-page">
      {/* Fixed Banner */}
      <div className="republic-banner-fixed">
        <h1 className="republic-title">Republic Day Celebration</h1>
      </div>

      {/* Content Wrapper (pushes content below fixed banner) */}
      <div className="republic-content-wrapper">
        {/* Quote */}
        <div className="republic-quote-below">
          Our children joyfully celebrated Republic Day, learning the values of
          freedom, unity, and respect.
        </div>

        {/* Main Content */}
        <div className="container republic-content">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-9">
              <p className="page-text">
                Our Republic Day celebration at The Gifted Child Pediatric
                Therapy Centre was a joyful and inspiring experience where
                children learned about the importance of{" "}
                <strong>freedom, unity, and national pride</strong>.
              </p>

              <p className="page-text">
                Through creative art activities, patriotic songs, group games,
                and flag-themed crafts, children expressed their love for the
                nation in ways that were meaningful and developmentally
                enriching.
              </p>

              <p className="page-text">
                Events like these nurture <strong>emotional expression</strong>,{" "}
                <strong>social interaction</strong>, and a strong sense of{" "}
                <strong>belonging</strong>, while making learning joyful and
                memorable.
              </p>
            </div>
          </div>

          {/* Image Gallery */}
          <section className="republic-gallery">
            <h2 className="section-heading text-center mb-4">
              Moments from the Republic Day Celebration
            </h2>

            <div className="gallery-grid">
              {republicImages.map((img) => (
                <img
                  key={img.id}
                  src={img.src}
                  alt={img.alt}
                  onClick={() => openImage(img)}
                />
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <span className="close-btn" onClick={closeImage}>
            ✕
          </span>

          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="modal-img"
            style={{ transform: `scale(${zoomLevel})` }}
            onWheel={handleZoom}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
